import React from "react";
import { Routes, Route } from "react-router-dom";
import { Dashboard } from "../pages/dashboard/Dashboard";
import Login from "../pages/login/Login";
import NotFound from "../components/Notfound";
import Bloc from "../pages/bloc";
import Sector from "../pages/sector/Sector";
import RegisterQuestionSector from "../pages/RegisterQuestionSector/RegisterQuestionSector";
import Questions from "../pages/question/Questions";
import QuestionSector from "../pages/questionSector/QuestionSector";
import Equipment from "../pages/equipment";
import Manufacturer from "../pages/manufacturer/manufacturer";
import SkuEquipment from "../pages/skuequipment/SkuEquipment";
import Reason from "../pages/Reason/Reason";
import TypeOccurrence from "../pages/typeOccurrence/typeOccurrence";
import Occurrence from "../pages/occurrence/occurrence";
import PackingList from "../pages/PackingList/PackingList";
import RegisterWorkInstructive from "../pages/WorkInstructive/RegisterWorkInstructive";
import WorkInstructive from "../pages/WorkInstructive/WorkInstructive";
import Invoice from "../pages/Invoice/Invoice";
import UserPermission from "../pages/user/User";
import BarcodeLogin from "../pages/barcodeGeneration/barcodeLogin";
import PrivateRoute from "./PrivateRoute";
import PermissionError from "../components/PermissionError";
import Group from "../pages/Group/Group";
import Reprocess from "../pages/Reprocess/Reprocess";
import UpdateUser from "../pages/user/UpdateUser";
import Molds from "../pages/molds/Molds";
import Maintenance from "../pages/maintenance/Maintenance";
import WebsocketContext from "../context/hooks/WebSocket";
import Combinations from "../pages/Combinations";
import { Wagon } from "../pages/wagon/wagon";
import { WagonApproved } from "../pages/wagonApproved/wagonApproved";
import TvFurnace from "../pages/tvFurnace/TvFurnace";
import MessageSector from "../pages/messageSector/MessageSector";
import ConfigPieceSector from "../pages/config/pieceSector/ConfigPieceSector";
import { HistoricWagon } from "../pages/historicWagon";
import { SAPNotifications } from "../pages/sapNotifications";
import { PartsInDevelopment } from "../pages/PartsInDevelopment";
import StatusMolde from "../pages/StatusMolde";
import { WagonsToAnalyze } from "../pages/WagonsToAnalyze/WagonsToAnalyze";
import { ValidacaoLogo } from "../pages/ValidacaoLogo/ValidacaoLogo";
import { HistoricLogo } from "../pages/historicLogo/HistoricLogo";
import { RastrearPecas } from "../pages/RastrearPecas/RastrearPecas";
import Fotolito from "../pages/fotolito";
import { HistoricoTelas } from "../pages/fotolito/HistoricoTelas";
import { ListaOrdens } from "../pages/fotolito/ListaOrdens";
import ListMontagem from "../pages/ListMontagem/ListMontagem";
import { Portaria } from "../pages/portaria/cadastro";
import { Entrada } from "../pages/portaria/entrada";
import { Pessoas } from "../pages/portaria/pessoas";
import { Apontamento_SAP } from "../pages/Apontamento";
import PrioridadePCP from "../pages/PCP";
import HistoricoApontamentos from "../pages/Apontamento/HistoricoApontamentos";


const Rotas = () => {
  return (
    <div>
      <Routes>
        <Route
          path="/rastrear-peças"
          element={
            <PrivateRoute permissionsRequired={[""]}>
              <WebsocketContext>
                <RastrearPecas />
              </WebsocketContext>
            </PrivateRoute>
          }
        />
        <Route
          path="/status-molde"
          element={
            <PrivateRoute permissionsRequired={[""]}>
              <WebsocketContext>
                <StatusMolde />
              </WebsocketContext>
            </PrivateRoute>
          }
        />
        <Route
          path="/parts-in-development"
          element={
            <PrivateRoute permissionsRequired={["Engenharia_tela"]}>
              <WebsocketContext>
                <PartsInDevelopment />
              </WebsocketContext>
            </PrivateRoute>
          }
        />
        <Route
          path="/historic-wagon"
          element={
            <PrivateRoute permissionsRequired={["TelaFornos"]}>
              <HistoricWagon />
            </PrivateRoute>
          }
        />
        <Route
          path="/historic-logo"
          element={
            <PrivateRoute permissionsRequired={[""]}>
              <HistoricLogo />
            </PrivateRoute>
          }
        />
        <Route
          path="/sapnotifications"
          element={
            <PrivateRoute permissionsRequired={["TelaFornos"]}>
              <WebsocketContext>
                <SAPNotifications />
              </WebsocketContext>
            </PrivateRoute>
          }
        />
        <Route
          path="/wagon"
          element={
            <PrivateRoute permissionsRequired={["TelaFornos"]}>
              <WebsocketContext>
                <Wagon />
              </WebsocketContext>
            </PrivateRoute>
          }
        />
        <Route
          path="/questions"
          element={
            <PrivateRoute permissionsRequired={["user", "admin", "DEV"]}>
              <Questions />
            </PrivateRoute>
          }
        />
        <Route
          path={`/dashboard/*`}
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
          exact
        />
        <Route
          path="/bloc"
          element={
            <PrivateRoute>
              <Bloc />
            </PrivateRoute>
          }
          exact
        />
        <Route
          path="/registerQuestionSector"
          element={
            <PrivateRoute>
              <RegisterQuestionSector />
            </PrivateRoute>
          }
          exact
        />
        <Route
          path="/sector"
          element={
            <PrivateRoute>
              <Sector />
            </PrivateRoute>
          }
          exact
        />
        <Route
          path="/questionSector"
          element={
            <PrivateRoute>
              <QuestionSector />
            </PrivateRoute>
          }
          exact
        />
        <Route
          path="/equipment"
          element={
            <PrivateRoute>
              <Equipment />
            </PrivateRoute>
          }
          exact
        />
        <Route
          path="/manufacturer"
          element={
            <PrivateRoute>
              <Manufacturer />
            </PrivateRoute>
          }
          exact
        />
        <Route
          path="/skuequipment"
          element={
            <PrivateRoute>
              <SkuEquipment />
            </PrivateRoute>
          }
          exact
        />
        <Route
          path="/reason"
          element={
            <PrivateRoute>
              <Reason />
            </PrivateRoute>
          }
          exact
        />
        <Route
          path="/combinacoes"
          element={
            <PrivateRoute permissionsRequired={["DEV"]}>
              <Combinations />
            </PrivateRoute>
          }
          exact
        />
        <Route
          path="/mensagem-setor"
          element={
            <PrivateRoute>
              <MessageSector />
            </PrivateRoute>
          }
          exact
        />
        <Route
          path="/typeOccurrence"
          element={
            <PrivateRoute>
              <TypeOccurrence />
            </PrivateRoute>
          }
          exact
        />
        <Route
          path="/occurrence"
          element={
            <PrivateRoute>
              <Occurrence />
            </PrivateRoute>
          }
          exact
        />
        <Route
          path="/criarInstrutivos"
          element={
            <PrivateRoute>
              <RegisterWorkInstructive />
            </PrivateRoute>
          }
          exact
        />
        <Route
          path="/instrutivos"
          element={
            <PrivateRoute>
              <WorkInstructive />
            </PrivateRoute>
          }
          exact
        />{" "}
        <Route
          path="/Apontamento_SAP"
          element={
            <PrivateRoute>
              <Apontamento_SAP />
            </PrivateRoute>
          }
          exact
        />

        <Route
          path="/Apontamento_SAP/Historico"
          element={
            <PrivateRoute>
              <HistoricoApontamentos />
            </PrivateRoute>
          }
          exact
        />
        <Route
          path="/Prioridade_PCP"
          element={
            <PrivateRoute>
              <PrioridadePCP />
            </PrivateRoute>
          }
          exact
        />
        <Route
          path="/portaria"
          element={
            <PrivateRoute permissionsRequired={["Portaria"]}>
              <Portaria />
            </PrivateRoute>
          }
          exact
        />{" "}
        <Route
          path="/entradas"
          element={
            <PrivateRoute permissionsRequired={["Portaria"]}>
              <Entrada />
            </PrivateRoute>
          }
          exact
        />{" "}
        <Route
          path="/pessoas"
          element={
            <PrivateRoute permissionsRequired={["Portaria"]}>
              <Pessoas />
            </PrivateRoute>
          }
          exact
        />{" "}
        <Route
          path="/invoice/:order"
          element={
            <PrivateRoute>
              <Invoice />
            </PrivateRoute>
          }
        />
        <Route
          path="/invoice"
          element={
            <PrivateRoute>
              <Invoice />
            </PrivateRoute>
          }
          exact
        />
        <Route
          path="/documentosExercito"
          element={
            <PrivateRoute>
              <PackingList />
            </PrivateRoute>
          }
          exact
        />
        <Route
          path="/userPermission"
          element={
            <PrivateRoute permissionsRequired={["admin", "DEV"]}>
              <UserPermission />
            </PrivateRoute>
          }
          exact
        />
        <Route
          path="/groupPermission"
          element={
            <PrivateRoute permissionsRequired={["admin", "DEV"]}>
              <Group />
            </PrivateRoute>
          }
          exact
        />
        <Route
          path="/reprocess"
          element={
            <PrivateRoute permissionsRequired={["Reprocesso_tela"]}>
              <Reprocess />
            </PrivateRoute>
          }
          exact
        />
        <Route
          path="/fotolito"
          element={
            <PrivateRoute>
              <Fotolito />
            </PrivateRoute>
          }
          exact
        />
        <Route
          path="/hitoricoTelas"
          element={
            <PrivateRoute>
              <HistoricoTelas />
            </PrivateRoute>
          }
          exact
        />
        <Route
          path="/listaOrdens"
          element={
            <PrivateRoute>
              <ListaOrdens />
            </PrivateRoute>
          }
          exact
        />
        <Route
          path="/moldes"
          element={
            <PrivateRoute>
              <WebsocketContext>
                <Molds />
              </WebsocketContext>
            </PrivateRoute>
          }
          exact
        />
        <Route
          path="/vagoesAprovados"
          element={
            <PrivateRoute>
              <WebsocketContext>
                <WagonApproved />
              </WebsocketContext>
            </PrivateRoute>
          }
        />
        <Route
          path="/wagons-to-analyze"
          element={
            <PrivateRoute>
              <WebsocketContext>
                <WagonsToAnalyze />
              </WebsocketContext>
            </PrivateRoute>
          }
        />
        {/* <Route
          path="/vagoesAprovados"
          element={
            <PrivateRoute>
              <WebsocketContext>
                <WagonApprovedTest />
              </WebsocketContext>
            </PrivateRoute>
          }
        /> */}
        <Route
          path="/manutencao"
          element={
            <PrivateRoute>
              <Maintenance />
            </PrivateRoute>
          }
          exact
        />
        <Route
          path="/tv-furnace"
          element={
            <PrivateRoute>
              <TvFurnace />
            </PrivateRoute>
          }
          exact
        />
        <Route
          path="/updateUser"
          element={
            <PrivateRoute>
              <UpdateUser />
            </PrivateRoute>
          }
          exact
        />
        <Route
          path="/configPieceSector"
          element={
            <PrivateRoute>
              <ConfigPieceSector />
            </PrivateRoute>
          }
          exact
        />
        <Route
          path="/barcodeGeneration"
          permissionsRequired={["DEV"]}
          element={
            <PrivateRoute>
              <BarcodeLogin />
            </PrivateRoute>
          }
          exact
        />
        <Route
          path="/validacao-logo"
          element={
            <PrivateRoute permissionsRequired={[""]}>
              <WebsocketContext>
                <ValidacaoLogo />
              </WebsocketContext>
            </PrivateRoute>
          }
        />
        <Route path="/listaMontagem" element={<ListMontagem />} />
        <Route path="/404" element={<NotFound />} exact />
        <Route path="PermissionError" element={<PermissionError />} />
        <Route path="*" element={<Login />} />
      </Routes>
    </div>
  );
};

export default Rotas;
